import {
  BoxProps,
  Grid,
  Text,
  useBreakpointValue,
  useTheme,
} from '@chakra-ui/react';
import React, { ComponentProps } from 'react';
import { METRICS_NAME } from '~/constants';
import { hexToRgbaString } from '~/utils';

import { MediaPackDetailHighlightCard } from '../../MediaPackDetailHighlightCard';
import { IMetricConfigSingle } from '../MediaPackDetailEditHighlightsModal.types';
import { IMetricCardProps } from './MetricCard.types';

type Props = Omit<BoxProps, 'onClick'> & IMetricCardProps<IMetricConfigSingle>;

export const MetricCardSingle: React.FC<Props> = ({
  benchmarks,
  isActive,
  metric,
  metricConfig,
  metricPosition,
  metrics,
  onClick,
  ...props
}) => {
  const { defaultMetricKey } = metricConfig;
  const isMobile = useBreakpointValue({ base: true, lg: false });
  const metricKey = metricPosition[0] ?? defaultMetricKey;
  const metricProps = metrics.find(({ key }) => key === metricKey);
  const theme = useTheme();

  if (!metricProps) {
    // eslint-disable-next-line no-console
    console.error(`${metricKey} is not defined, established metrics:`, metrics);
    return null;
  }

  const highlightCardProps: ComponentProps<
    typeof MediaPackDetailHighlightCard
  > = {
    ...metricProps,
    value: benchmarks[metricKey] ?? 'n/a',
    metricKey: defaultMetricKey,
  };

  const handleClick = () => {
    onClick && onClick(metric);
  };

  return (
    <Grid>
      {!isMobile && (
        <Text
          color="primary.500"
          fontSize="md"
          fontWeight={500}
          marginBottom={3}
        >
          {METRICS_NAME[metric]}:
        </Text>
      )}

      <MediaPackDetailHighlightCard
        cursor={onClick ? 'pointer' : undefined}
        borderWidth={isActive ? '2px' : '1px'}
        borderColor={isActive ? 'secondary.500' : 'primary.200'}
        backgroundColor={
          isActive
            ? hexToRgbaString(theme.colors.secondary[50], 0.2)
            : undefined
        }
        onClick={handleClick}
        {...highlightCardProps}
        {...props}
      />
    </Grid>
  );
};
